import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-osa-execucao',
  templateUrl: './osa-execucao.component.html',
  styleUrls: ['./osa-execucao.component.scss']
})
export class OsaExecucaoComponent implements OnInit {

  constructor() { }

  public situacaoSelecionada: number = 2;

  ngOnInit(): void {
  }

}
